import React, { useEffect } from 'react';
import { useThemeMode } from '../../contexts/ThemeContext';

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout wrapper for authentication pages that forces light theme
 * Auth pages always use light theme regardless of user's theme preference
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { setThemeMode } = useThemeMode();

  useEffect(() => {
    // Force light theme for auth pages
    setThemeMode('light');

    // Cleanup: restore theme preference when leaving auth pages
    // (optional - theme will be restored when user navigates to dashboard)
  }, [setThemeMode]);

  return <>{children}</>;
};

export default AuthLayout;
